import React from 'react'
import { PaymentMethod } from '@entities/payment'
import MTSAccountLogo from '../../assets/MTSAccountLogo'
import SBPLogo from '../../assets/SBPLogo'

export const paymentMethods = [
  {
    type: PaymentMethod.SBP,
    icon: <SBPLogo />,
  },
  {
    type: PaymentMethod.MTS_ACCOUNT,
    icon: <MTSAccountLogo />,
  },
]
